import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { getFAQs } from '../services/api';

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      setLoading(true);
      try {
        const data = await getFAQs(i18n.language);
        setFaqs(data);
        setError(null);
      } catch (err) {
        setError(t('faqLoadError'));
        console.error('Failed to load FAQs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, [i18n.language, t]);

  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading) {
    return <div className="loading-faq">{t('loading')}</div>;
  }

  if (error) {
    return <div className="error-faq">{error}</div>;
  }

  return (
    <>
      <h2>{t('faqTitle')}</h2>
      <div className="faq-section">
        <div className="faq-list">
          {faqs.length === 0 ? (
            <p>{t('noFaqsAvailable')}</p>
          ) : (
            faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                  <h3>{faq.question}</h3>
                  <span className="faq-toggle">{openIndex === index ? '−' : '+'}</span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">
                    <ReactMarkdown
                      components={{
                        a({ node, children, ...props }) {
                          let url = new URL(props.href ?? '', location.href);
                          if (url.origin !== location.origin) {
                            props.target = '_blank';
                            props.rel = 'noopener noreferrer';
                          }

                          return <a {...props}>{children}</a>;
                        },
                      }}
                    >
                      {faq.answer}
                    </ReactMarkdown>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default FAQ;
